import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { SliceZone } from '@prismicio/react'

import { components } from 'slices/'

import { PageDocument } from 'types/prismic'
import { getFullPageByUID } from 'utils/prismic'

const Custom404 = (props: { page: PageDocument<string> }) => (
  <div className="h-full bg-gray-50 py-20 px-10 text-center">
    <SliceZone slices={props.page.data.slices} components={components as any} />
  </div>
)

export const getStaticProps: GetStaticProps = async ({
  locale: currentLocale,
  previewData,
  defaultLocale
}) => {
  const locale = currentLocale || defaultLocale || 'en'

  const pagePartsPromise = getFullPageByUID(
    'notFound',
    'org',
    { locale },
    { previewData }
  )

  const i18nPromise = serverSideTranslations(locale, [
    'notFound',
    'actions',
    'crm'
  ])

  const [pageParts, i18n] = await Promise.all([pagePartsPromise, i18nPromise])

  const { page, ...layoutParts } = pageParts

  return {
    props: {
      ...i18n,
      page,
      internal: {
        layout: layoutParts
      }
    },
    revalidate: 60 * 15 // 15 minutes
  }
}

export default Custom404
